<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/healthcare/client_shriners.jpg">
            Shriners Hospitals
        </client-card>
        <client-card src="img/clients-color/healthcare/hopital-sacre-coeur.png">
            Hopital Sacre Coeur
        </client-card>
        <client-card src="img/clients-color/healthcare/fondation-mathieu-froment-savoie.png">
            Fondation Mathieu Froment Savoie
        </client-card>
        <client-card src="img/clients-color/healthcare/institut-physimed.png" bg>
            Institut Physimed
        </client-card>
        <client-card src="img/clients-color/healthcare/institut-douglas.png" bg>
            Institut Douglas
        </client-card>
        <client-card src="img/clients-color/healthcare/maison-collines.png" bg>
            La Maison des Collines
        </client-card>
        <client-card src="img/clients-color/healthcare/hopital-montfort.png" bg>
            Hopital Montfort
        </client-card>
        <client-card src="img/clients-color/healthcare/fondation_sante_gatineau.png" bg>
            Fondation Sante Gatineau
        </client-card>
        <client-card src="img/clients-color/healthcare/ciusss.png" bg>
            CIUSSS
        </client-card>
        <client-card src="img/clients-color/healthcare/centre-services-scolaire-patriotes.png">
            Centre Services Scolaire Patriotes
        </client-card>
        <client-card src="img/clients-color/healthcare/chsld.png">
            CHSLD JECB
        </client-card>
        <client-card src="img/clients-color/healthcare/csss_bordeaux.png">
            CSSS Bordeaux
        </client-card>
        <client-card src="img/clients-color/healthcare/miriam.png">
            Fondation Miriam
        </client-card>
        <client-card src="img/clients-color/healthcare/institut_philippe_pinel.png">
            Institut Philippe Pinel
        </client-card>
        <client-card src="img/clients-color/healthcare/maimonides.png">
            Maimonides
        </client-card>
        <client-card src="img/clients-color/healthcare/csss_la_montagne.png">
            CSSS La Montagne
        </client-card>
        <client-card src="img/clients-color/healthcare/hopital_chinois.png">
            Hopital Chinois de Montréal
        </client-card>
        <client-card src="img/clients-color/healthcare/clinique_ovo.png">
            Clinique Ovo
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `signage-healthcare-client-cards`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Healthcare Digital Signage Client|Client santé médical affichage numérique`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
